import { forwardRef } from "react";
import type { SVGIconProps } from "../types";

export const OsWindowsIcon = forwardRef<SVGSVGElement, SVGIconProps>(
  ({ color = "currentColor", size = 16, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_51_306"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="16"
      >
        <rect width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_51_306)">
        <path
          d="M1.95874 7.65789V4.06579L6.064 3.16263V7.59632L1.95874 7.65789ZM13.5903 1.5V7.48684L6.74821 7.58947V3.01211L13.5903 1.5ZM1.95874 8.34211L6.064 8.40368V13.0632L1.95874 12.2763V8.34211ZM13.5903 8.51316V14.5L6.74821 13.1932V8.41053L13.5903 8.51316Z"
          fill={color}
        />
      </g>
    </svg>
  ),
);

OsWindowsIcon.displayName = "OsWindowsIcon";
